import { Fragment, useContext } from "react";
import List from "@mui/material/List";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import NavItem from "./NavItem";
import DrawerHeader from "./DrawerHeader";
import { ReactComponent as FayeIcon } from "../../icons/FayeBrand.svg";
import { ReactComponent as ClipboardIcon } from "../../icons/Menu/Clipboard.svg";
import { ReactComponent as IdeaIcon } from "../../icons/Menu/Idea.svg";
import { ReactComponent as CalendarIcon } from "../../icons/Menu/Calendar.svg";
import { ReactComponent as HomeIcon } from "../../icons/Menu/Home.svg";
import { ReactComponent as LoveIcon } from "../../icons/Menu/Love.svg";
import { ReactComponent as GiftIcon } from "../../icons/Menu/Gift.svg";
import CurrentUserAvatar from "../common/CurrentUserAvatar";
import LinkRouter from "../navigation/LinkRouter";
import { CurrentUserContext } from "../context/RequireAuth";
import { Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useGetMemberDetails } from "services/member";

const AddMemberTaskButton = ({}: {}) => {
  const navigate = useNavigate();
  const { request, loading, data } = useGetMemberDetails();
  const onClick = async () => {
    let family = data?.family;
    if (!family) {
      const resp = await request();
      family = resp?.family;
    }
    if (family) {
      navigate("/tasks/add", { state: { family } });
    }
  };
  return (
    <Button
      variant="outlined"
      size="small"
      sx={{
        marginLeft: "16px",
        marginTop: "48px",
      }}
      onClick={onClick}
      disabled={loading}
    >
      New task
    </Button>
  );
};

type MemberDrawerContentProps = {
  isPersistent: boolean;
  selectedTab: string;
  open: boolean;
  setClosed(): void;
  isMobile: boolean;
};

export default ({
  isPersistent,
  selectedTab,
  open,
  setClosed,
}: MemberDrawerContentProps) => {
  const currentUser = useContext(CurrentUserContext);
  return (
    <Fragment>
      <List sx={{ padding: 0 }}>
        <DrawerHeader>
          {isPersistent && (
            <LinkRouter to="/">
              <FayeIcon
                style={{
                  height: "26px",
                  margin: "12px 0px",
                }}
              />
            </LinkRouter>
          )}
          {!isPersistent && (
            <IconButton
              onClick={() => setClosed()}
              sx={{ ml: "auto", marginRight: "10px" }}
            >
              <CloseIcon sx={{ color: "#545F71" }} />
            </IconButton>
          )}
        </DrawerHeader>
        <div style={{ paddingTop: "17px" }}>
          <NavItem
            selected={selectedTab === "/home"}
            open={open}
            onClick={setClosed}
            icon={<HomeIcon />}
            text="Home"
            url="/home"
          />
          <NavItem
            selected={selectedTab === "/family-info"}
            open={open}
            onClick={setClosed}
            icon={<LoveIcon />}
            text="Family info"
            url="/family-info"
          />
          <NavItem
            selected={
              selectedTab === "/tasks" || selectedTab.startsWith("/tasks/")
            }
            open={open}
            onClick={setClosed}
            icon={<ClipboardIcon />}
            text="Tasks"
            url="/tasks"
          />
          <NavItem
            selected={selectedTab === "/task-discovery"}
            open={open}
            onClick={setClosed}
            icon={<IdeaIcon fill="#6B6E7B" />}
            text="Task discovery"
            url="/task-discovery"
          />
          <NavItem
            selected={selectedTab === "/calendar"}
            open={open}
            onClick={setClosed}
            icon={<CalendarIcon />}
            text="Calendar"
            url="/calendar"
          />
          <NavItem
            selected={selectedTab === "/invite"}
            open={open}
            onClick={setClosed}
            icon={<GiftIcon />}
            text="Invite friends"
            url="/invite"
          />
          <AddMemberTaskButton />
        </div>
      </List>
      <List>
        <NavItem
          selected={selectedTab === "/settings"}
          onClick={setClosed}
          open={open}
          icon={<CurrentUserAvatar size={48} />}
          text={currentUser.firstName}
          url="/settings"
        />
      </List>
    </Fragment>
  );
};
